export enum AppRoutes {
  MAIN = "main",
  DASHBOARD = "dashboard",
  ARCHIVED_COMPANIES = "archived-companies",
  COMPANIES = "companies",
  ADD_COMPANY = "add-company",
  PORTFOLIO_COMPANY_PROFILE = "portfolio-company-profile",
  EXPERT_PORTFOLIO_COMPANY_PROFILE = "expert-portfolio-company-profile",
  FOUNDER_COMPANY_PROFILE = "founder-company-profile",
  COMPANY_PROFILE = "company-profile",
  SETTINGS = "settings",
  PRIVACY_NOTICE = "privacy-notice",
  TERMS_OF_USE = "terms-of-use",
  SIGNIN = "sign-in",
  FORGOT_PASSWORD = "forgot-password",
  RESET_PASSWORD = "reset-password",
  SIGNUP = "sign-up",
  FOUNDER_SIGN_UP = "founder-sign-up",
  EXPERT_SIGN_UP = "expert-sign-up",
  EXPERT_ROOT_PAGE = "expert-root",
  EXPERT_ORGANIZATION_BY_ID = "expert-organization-by-id",
  EXPERT_COMPANIES_BY_ID = "expert-companies-by-id",
  EXPERT_COMPANY_PROFILE = "expert-company-profile",
  DEUTSCHE_TELEKOM = "deutche-telekom",
  APPLICATION_FORM_SIGN_UP = "application-form-sign-up",
  WRONG_PAGE = "wrong-page"
}

export const getRouteMain = () => "/";
export const getRouteDashboard = () => "/dashboard";
export const getRouteExpertRootPage = () => "/expert-dashboard";
export const getRouteCompanies = () => "/companies";
export const getRouteAddCompany = () => "/add-company";
export const getRoutePortfolioCompanyProfile = (id: number | string) => `/portfolio-company-profile/${id}`;
export const getRouteExpertCompanyProfile = (organizationId: number | string, id: number | string) =>
  `/expert-organization/${organizationId}/company-profile/${id}`;
export const getRouteExpertPortfolioCompanyProfile = (organizationId: number | string, id: number | string) =>
  `/expert-organization/${organizationId}/portfolio-company-profile/${id}`;
export const getRouteFounderCompanyProfile = () => `/founder-company-profile`;
export const getRouteCompanyProfile = (id: number | string) => `/company-profile/${id}`;
export const getRouteSettingsPage = () => "/settings";
export const getRoutePrivacyNotice = () => "/privacy-notice";
export const getRouteTermsOfUse = () => "/terms-of-use";
export const getRouteSignIn = () => "/sign-in";
export const getRouteResetPassword = () => "/reset-password";
export const getRouteForgotPassword = () => "/forgot-password";
export const getRouteSignUp = () => "/sign-up";
export const getRouteFounderSignUp = () => "/founder-sign-up";
export const getRouteExpertSignUp = () => "/expert-sign-up";
export const getRouteExpertOrganizationById = (id: number | string) => `/expert-dashboard/organizations/${id}`;
export const getRouteExpertCompaniesById = (id: number | string) => `/expert/organizations/${id}/companies`;
export const getRouteArchivedCompanies = () => "/archived-companies";
export const getRouteDeutscheTelekom = () => "/application-form/deutsche-telekom";
export const getRouteApplicationFormSignUp = () => "/application-form/sign-up";
export const getRouteWeAreDeploying = () => "/we-are-deploying";
